export default __webpack_public_path__ + "static/media/photo--lg--pubquiz.fecd28f2.jpg";